<div [formGroup]="configFormGroup">
  <h2>Power Bi Config</h2>
  <div dwRow>
    <div dwCol="6">
      <label>WorkspaceId</label>

        <input type="text" formControlName="workspaceId" class="form-control">

    </div>
  </div>
  <div dwRow>
    <div dwCol="6">
      <label>ReportId</label>

        <input type="text" formControlName="reportId" class="form-control">

    </div>
  </div>
  <div dwRow>
    <div dwCol="6">
      <label>Filters</label>
      <select multiple=true formControlName="filters" class="form-control">
        <option *ngFor="let attr of itemMetaData?.Attributes" [ngValue]="attr.AttributeName">
          {{ attr.Display }}
        </option>
      </select>
    </div>
  </div>

  <div dwRow>
    <div dwCol="6">
      <label>Context Filters</label>
      <select multiple=true formControlName="filtersContext" class="form-control" [compareWith]="compareFn">
        <option *ngFor="let attr of contextMetaData" [ngValue]="attr">{{ attr.selected}} {{ attr.Display }}</option>
      </select>
    </div>
  </div>

  <div dwRow>
    <div dwCol="6">
      <label>Tables</label>
      <input type="text" formControlName="tableNames" class="form-control">
    </div>
  </div>
</div>
